import React from 'react';
import './style.css';
import certificateImage from '../../assests/About/certificate.png';
import trophyIcon from '../../assests/About/trophy.png'; // Import trophy icon
import bcaImage from '../../assests/About/bca.jpeg'; // Import trophy icon
import Navbar from '../../Components/Navbar';
import Footer from '../../Components/Footer';

const Accreditations = () => {
  return (
    <>
      <Navbar />
      <section className="accreditations-wrapper">
        <div className="accreditations-content fade-in-left">
          <h2>Our Accreditations</h2>
          <h4 className="tagline">
            Certified Safe. <span>Certified Strong.</span>
          </h4>

          <p className="intro">
            We are proud to be recognized for our commitment to quality, safety,
            and excellence through the following accreditations:
          </p>

          <div className="accreditation-list">
            <div className="accreditation-item">
              <h3>
              <img src={trophyIcon} alt="Trophy" className="trophy-icon" width={50} height={50} /> bizSAFE Certified
              </h3>
              <p>Demonstrating our strong commitment to workplace safety and health.</p>
            </div>

            <div className="accreditation-item">
              <h3>
                <img src={trophyIcon} alt="Trophy" className="trophy-icon" width={50} height={50} /> IAS Accredited
              </h3>
              <p>Ensuring our services meet international standards of quality and compliance.</p>
            </div>

            <div className="accreditation-item">
              <h3>
            <img src={trophyIcon} alt="Trophy" className="trophy-icon" width={50} height={50} /> ISO 9001 Certified
              </h3>
              <p>Recognizing our quality management systems and continuous improvement processes.</p>
            </div>

            <div className="accreditation-item">
              <h3>
               <img src={trophyIcon} alt="Trophy" className="trophy-icon" width={50} height={50} /> ISO 45001 Certified
              </h3>
              <p>Highlighting our proactive approach to occupational health and safety management.</p>
            </div>
          </div>
        </div>

        <div className="accreditations-image fade-in-right">
          <img src={certificateImage} alt="Certificate" />
        </div>
      </section>
       <section className="bca-cert">
      <div className="bca-content">
        <h2>BCA-Certified Construction Company</h2>
        <p>
          Innovation Solutions is a <strong>BCA-certified construction company</strong>
          in Singapore, committed to delivering high-quality, safe, and reliable
          construction services. Our certification by the Building and Construction
          Authority (BCA) ensures compliance with industry standards and excellence
          in every project we undertake.
        </p>
        <p>
          From residential to commercial projects, we provide end-to-end construction
          solutions you can trust.
        </p>
      </div>

      <div className="bca-image">
        <img src={bcaImage} alt="BCA Certification" />
      </div>
    </section>
      <Footer />
    </>
  );
};

export default Accreditations;
